import { render, staticRenderFns } from "./DetailUnit.vue?vue&type=template&id=15fd8140"
import script from "./DetailUnit.vue?vue&type=script&lang=js"
export * from "./DetailUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports